<template>
  <v-dialog
    persistent
    v-model="dialog"
    scrollable
    @keydown.esc="dialog = false"
    width="850"
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Name"
                v-model="selectedLuCity.Name"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- CityCounties Join Items-->
          <v-row>
            <v-col sm="12">
              <LuCounty
                label="County"
                v-model="selectedLuCity.Counties"
                return-object
              ></LuCounty>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuCity.IsActive"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="saveLuCityDetails" :disabled="saving" color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuCity from '@classes/LuCity'
//templateTODO: import lookup components you plan to use
import LuCounty from '@components/select/LuCounty/LuCounty-a-multi-id'
export default {
  components: {
    //templateTodo: define lookup components you are using
    LuCounty,
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuCity: new LuCity(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luCity', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luCity', ['saveLuCity']),
    async validate() {
      await this.$refs.form.validate()
    },
    editLuCity(entry) {
      this.selectedLuCity = new LuCity(entry)
      this.modalText = 'Edit City'
      this.dialog = !this.dialog
    },
    addLuCity() {
      this.modalText = 'Insert City'
      this.selectedLuCity = new LuCity()
      this.dialog = !this.dialog
    },
    async saveLuCityDetails() {
      await this.validate()
      if (this.valid) {
        //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
        try {
          await this.saveLuCity(this.selectedLuCity.removeRelated())
          this.$emit('refresh')
          this.$emit('itemAdded', res.data)
          this.selectedLuCity = new LuCity()
          this.$refs.form.resetValidation()
        } catch (err) {}
        this.dialog = false
      }
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuCity = new LuCity()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
